"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playScoreResultProps = exports.default = void 0;

var _vue = require("vue");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slider = _interopRequireDefault(require("ant-design-vue/lib/slider"));

require("ant-design-vue/lib/slider/style/index.css");

var _lodash = _interopRequireDefault(require("lodash"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var playScoreResultProps = {
  recordScore: Object,
  playMode: {
    type: String,
    default: 'ori'
  },
  userDelay: {
    type: Number,
    default: 0
  },
  userVolume: {
    type: Number,
    default: 1
  },
  accVolume: {
    type: Number,
    default: 1
  },
  playAudioMixerState: {
    type: String,
    default: 'pause'
  },
  recordReplayVisible: {
    type: Boolean,
    default: false
  },
  recordResultVisible: {
    type: Boolean,
    default: true
  },
  currentTime: {
    type: Number,
    default: 0
  },
  duration: {
    type: Number,
    default: 0
  },
  recordUploadData: Object,
  setCurrentMixerTime: Function,
  handleMergeSound: Function,
  changePlayScoreLoading: Function,
  openReplay: Function,
  onUploadRecordScore: Function,
  replayPlayParams: Object // 播放配置

};
exports.playScoreResultProps = playScoreResultProps;
var PlayScoreResult = (0, _vue.defineComponent)({
  name: 'PlayScoreResult',
  components: {
    Slider: _slider.default
  },
  props: playScoreResultProps,
  emits: ['update:userDelay', 'update:userVolume', 'update:accVolume', 'update:playAudioMixerState', 'update:recordReplayVisible', 'update:recordResultVisible'],
  setup: function setup(props, ctx) {
    var _this = this;

    var recordScore = (0, _vue.ref)(props.recordScore);
    var playMode = (0, _vue.ref)(props.playMode);
    var replayPlayParams = (0, _vue.ref)(props.replayPlayParams);
    var handle = (0, _vue.ref)(null); //游标

    var slider = (0, _vue.ref)(); //滑动条

    var sliderWidth = (0, _vue.computed)(function () {
      if (slider.value) {
        return slider.value.offsetWidth;
      }

      return 1;
    });
    var sliderWidthPer = (0, _vue.ref)(1); // 实际slider宽度缩小比例

    var plusButton = (0, _vue.ref)();
    var vocalAlignment = (0, _vue.ref)(props.userDelay / -50);
    var minusButton = (0, _vue.ref)();
    var tickArr = [];
    var isDragging = (0, _vue.ref)(false);
    var isHandleDragging = (0, _vue.ref)(false);
    var handleOrigin = (0, _vue.ref)(0);
    var min = -10;
    var max = 10;

    var setSliderDragging = function setSliderDragging(state) {
      isDragging.value = state;
    };

    var progress = (0, _vue.ref)(0);
    (0, _vue.watch)(function () {
      return props.currentTime;
    }, function () {
      if (!isDragging.value) {
        progress.value = props.currentTime / props.duration * 100;
      }
    });
    var userDelay = (0, _vue.computed)(function () {
      return props.userDelay;
    });
    var userVolume = (0, _vue.ref)(props.userVolume);
    var accVolume = (0, _vue.ref)(props.accVolume);
    var duration = (0, _vue.computed)(function () {
      return props.duration;
    });
    var currentTime = (0, _vue.computed)(function () {
      return props.currentTime;
    });
    var isPlaying = (0, _vue.computed)(function () {
      return props.playAudioMixerState === 'play';
    }); //生成tickArr

    for (var i = 0; i <= 10; i++) {
      tickArr.push(i * 10);
    }

    var parseTime = function parseTime(seconds) {
      if (!seconds) {
        return '00:00';
      }

      var prefixZero = function prefixZero(num, n) {
        return (Array(n).join('0') + num).slice(-n);
      };

      var m = parseInt("".concat(seconds / 60), 10);
      var s = parseInt("".concat(seconds % 60), 10);
      return "".concat(prefixZero(m, 2), ":").concat(prefixZero(s, 2));
    }; // 打开回放弹窗


    var handleOpenReplay = function handleOpenReplay() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var resultAudio;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isPlaying.value && changePlayState();
                props.changePlayScoreLoading(true, '音频生成中...');
                _context.prev = 2;
                _context.next = 5;
                return props.handleMergeSound();

              case 5:
                resultAudio = _context.sent;
                props.openReplay(resultAudio);
                ctx.emit('update:recordReplayVisible', true);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                console.error('音频合成失败', _context.t0);

              case 13:
                _context.prev = 13;
                props.changePlayScoreLoading(false);
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10, 13, 16]]);
      }));
    }; // 上传录音评分数据


    var handleUpload = function handleUpload() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isPlaying.value && changePlayState();
                _context2.next = 3;
                return props.onUploadRecordScore(_lodash.default.cloneDeep(props.recordUploadData));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }; // 播放进度


    var changeProgress = function changeProgress(newVal) {
      props.setCurrentMixerTime(newVal / 100 * duration.value);
      isDragging.value = false;
    };

    var changeAccVolume = function changeAccVolume(num) {
      ctx.emit('update:accVolume', num);
    };

    var changeUserVolume = function changeUserVolume(num) {
      ctx.emit('update:userVolume', num);
    };

    var changePlayState = function changePlayState() {
      if (isPlaying.value) {
        ctx.emit('update:playAudioMixerState', 'pause');
      } else {
        ctx.emit('update:playAudioMixerState', 'play');
      }
    };

    var closePlayScoreResultModal = function closePlayScoreResultModal() {
      ctx.emit('update:recordResultVisible', false);
    };

    var handleDragStart = function handleDragStart(e) {
      var _a;

      e.preventDefault();
      isHandleDragging.value = true;
      var tick0 = (_a = slider.value.getElementsByClassName('tick')) === null || _a === void 0 ? void 0 : _a[0];
      handleOrigin.value = tick0.getBoundingClientRect().left;
      sliderWidthPer.value = sliderWidth.value / slider.value.getBoundingClientRect().width;
    };

    var handleDragging = function handleDragging(e) {
      e.preventDefault();

      if (isHandleDragging.value) {
        var pixelsPerUnit = sliderWidth.value / (max - min) / 2;
        var left = e.clientX || e.touches[0].clientX;
        var currentHandleLeft = (left - handleOrigin.value) * sliderWidthPer.value;

        if (currentHandleLeft < 0) {
          currentHandleLeft = 0;
          vocalAlignment.value = -20;
        } else if (currentHandleLeft > sliderWidth.value) {
          currentHandleLeft = sliderWidth.value;
          vocalAlignment.value = 20;
        } else {
          var currentCell = +(currentHandleLeft / pixelsPerUnit).toFixed(0);
          currentHandleLeft = currentCell * pixelsPerUnit;
          vocalAlignment.value = currentCell - 20;
        }

        ctx.emit('update:userDelay', vocalAlignment.value * -50);
        handle.value.style.left = currentHandleLeft + 'px';
      }
    };

    var handleDragOver = function handleDragOver() {
      isHandleDragging.value = false;
    };

    (0, _vue.onMounted)(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var pixelsPerUnit, calculateCurPos;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // const sliderWidth = slider.value.offsetWidth;
                pixelsPerUnit = sliderWidth.value / (max - min) / 2; // handle.value.style.left = sliderWidth / 2 + 'px';

                handle.value.style.left = -1 * userDelay.value / 50 * pixelsPerUnit + sliderWidth.value / 2 + 'px'; // const tick0 = slider.value.getElementsByClassName('tick')?.[0];
                // handleOrigin.value = tick0.getBoundingClientRect().left;

                handle.value.addEventListener('mousedown', handleDragStart);
                handle.value.addEventListener('touchstart', handleDragStart);
                slider.value.addEventListener('mousemove', handleDragging);
                slider.value.addEventListener('touchmove', handleDragging);
                document.addEventListener('mouseup', handleDragOver);
                document.addEventListener('touchend', handleDragOver);

                minusButton.value = function () {
                  var newPosition = parseFloat(handle.value.style.left) - pixelsPerUnit;
                  vocalAlignment.value--;

                  if (newPosition < 0) {
                    newPosition = 0;
                    vocalAlignment.value = -20;
                  }

                  handle.value.style.left = newPosition + 'px';
                  calculateCurPos();
                  ctx.emit('update:userDelay', vocalAlignment.value * -50);
                };

                plusButton.value = function () {
                  var newPosition = parseFloat(handle.value.style.left) + pixelsPerUnit;
                  vocalAlignment.value++;

                  if (newPosition > sliderWidth.value) {
                    newPosition = sliderWidth.value;
                    vocalAlignment.value = 20;
                  }

                  handle.value.style.left = newPosition + 'px';
                  calculateCurPos();
                  ctx.emit('update:userDelay', vocalAlignment.value * -50);
                };

                calculateCurPos = function calculateCurPos() {//计算当前刻度值，返回值从-1到1
                  // const curPos = (handle.value.offsetLeft - sliderWidth / 2.0) / (sliderWidth / 2.0);
                };

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    });
    (0, _vue.onBeforeUnmount)(function () {
      isPlaying.value && changePlayState();
      handle.value.removeEventListener('mousedown', handleDragStart);
      handle.value.removeEventListener('touchstart', handleDragStart);
      slider.value.removeEventListener('mousemove', handleDragging);
      slider.value.removeEventListener('touchmove', handleDragging);
      document.removeEventListener('mouseup', handleDragOver);
      document.removeEventListener('touchend', handleDragOver);
    });
    return {
      userDelay: userDelay,
      isPlaying: isPlaying,
      playMode: playMode,
      handle: handle,
      tickArr: tickArr,
      slider: slider,
      vocalAlignment: vocalAlignment,
      minusButton: minusButton,
      plusButton: plusButton,
      recordScore: recordScore,
      progress: progress,
      userVolume: userVolume,
      accVolume: accVolume,
      duration: duration,
      currentTime: currentTime,
      replayPlayParams: replayPlayParams,
      isDragging: isDragging,
      setSliderDragging: setSliderDragging,
      changeAccVolume: changeAccVolume,
      changeUserVolume: changeUserVolume,
      changeProgress: changeProgress,
      changePlayState: changePlayState,
      parseTime: parseTime,
      handleOpenReplay: handleOpenReplay,
      handleUpload: handleUpload,
      closePlayScoreResultModal: closePlayScoreResultModal
    };
  },
  render: function render() {
    var _this2 = this;

    return (0, _vue.createVNode)("div", {
      "class": "play-score-result"
    }, [(0, _vue.createVNode)("div", {
      "class": "remind"
    }, [(0, _vue.createVNode)("div", {
      "class": "remindWrapper"
    }, [(0, _vue.createVNode)("div", {
      "class": "remind-header"
    }, null), (0, _vue.createVNode)("div", {
      "class": "comprehensiveScore"
    }, [(0, _vue.createVNode)("span", null, [(0, _vue.createTextVNode)("\u7EFC\u5408\u5F97\u5206")]), (0, _vue.createVNode)("span", {
      "class": "grade",
      "style": {
        marginTop: '8px'
      }
    }, [parseInt(this.recordScore.totalScore)])]), (0, _vue.createVNode)("div", {
      "class": "gradeWrapper"
    }, [(0, _vue.createVNode)("div", null, [(0, _vue.createVNode)("span", null, [(0, _vue.createTextVNode)("\u97F3\u51C6")]), (0, _vue.createVNode)("h2", {
      "style": {
        marginTop: '8px'
      }
    }, [parseInt(this.recordScore.pitchScore)])]), (0, _vue.createVNode)("div", null, [(0, _vue.createVNode)("span", null, [(0, _vue.createTextVNode)("\u8282\u594F")]), (0, _vue.createVNode)("h2", {
      "style": {
        marginTop: '8px'
      }
    }, [parseInt(this.recordScore.rhythmScore)])])]), (0, _vue.createVNode)("div", {
      "class": "volumeBar",
      "style": this.playMode === 'acc' || this.playMode === 'ori' ? 'height:250px' : 'height:100px'
    }, [(0, _vue.createVNode)("div", {
      "class": "volumeContainer",
      "style": this.playMode === 'acc' || this.playMode === 'ori' ? '' : 'display:none'
    }, [(0, _vue.createVNode)("div", {
      "class": "vocal-align"
    }, [(0, _vue.createVNode)("div", {
      "class": "vocal-align-title"
    }, [(0, _vue.createTextVNode)("\u4EBA\u58F0\u5BF9\u9F50")]), (0, _vue.createVNode)("div", {
      "class": "vocal-align-btn"
    }, [(0, _vue.createVNode)("div", {
      "class": "vocal-align-minus",
      "onClick": this.minusButton
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "vocal-align-slider",
      "ref": "slider"
    }, [(0, _vue.createVNode)("div", {
      "class": "handle",
      "ref": "handle"
    }, null), this.tickArr.map(function (item) {
      return (0, _vue.createVNode)("div", {
        "class": "tick",
        "style": "left:".concat(item, "%")
      }, null);
    }), (0, _vue.createVNode)("div", {
      "class": "vocal-align-text"
    }, [this.vocalAlignment < 0 ? "\u4EBA\u58F0\u5EF6\u540E".concat(this.vocalAlignment * -50, "\u6BEB\u79D2") : "\u4EBA\u58F0\u63D0\u524D".concat(this.vocalAlignment * 50, "\u6BEB\u79D2")])]), (0, _vue.createVNode)("div", {
      "class": "vocal-align-btn"
    }, [(0, _vue.createVNode)("div", {
      "class": "vocal-align-plus",
      "onClick": this.plusButton
    }, null)])]), (0, _vue.createVNode)("div", {
      "class": "volume"
    }, [(0, _vue.createVNode)("div", {
      "class": "volume-title"
    }, [(0, _vue.createTextVNode)("\u4F34\u594F\u97F3\u91CF")]), (0, _vue.createVNode)(_slider.default, {
      "class": 'slider',
      "min": 0,
      "max": 2,
      "tooltipVisible": false,
      "value": _this2.accVolume,
      "onUpdate:value": function onUpdateValue($event) {
        return _this2.accVolume = $event;
      },
      "step": 0.1,
      "onChange": this.changeAccVolume
    }, null), (0, _vue.createVNode)("div", {
      "class": "volume-num"
    }, [this.accVolume.toFixed(1)])]), (0, _vue.createVNode)("div", {
      "class": "volume"
    }, [(0, _vue.createVNode)("div", {
      "class": "volume-title"
    }, [(0, _vue.createTextVNode)("\u4EBA\u58F0\u97F3\u91CF")]), (0, _vue.createVNode)(_slider.default, {
      "class": 'slider',
      "min": 0,
      "max": 2,
      "step": 0.1,
      "tooltipVisible": false,
      "value": _this2.userVolume,
      "onUpdate:value": function onUpdateValue($event) {
        return _this2.userVolume = $event;
      },
      "onChange": this.changeUserVolume
    }, null), (0, _vue.createVNode)("div", {
      "class": "volume-num"
    }, [this.userVolume.toFixed(1)])])]), (0, _vue.createVNode)("div", {
      "class": "record-player"
    }, [(0, _vue.createVNode)("div", {
      "class": this.isPlaying ? 'pauseBtn' : 'playBtn',
      "onClick": this.changePlayState
    }, null), (0, _vue.createVNode)(_slider.default, {
      "class": 'slider',
      "tooltipVisible": false,
      "min": 0,
      "step": 1,
      "max": 100,
      "value": _this2.progress,
      "onUpdate:value": function onUpdateValue($event) {
        return _this2.progress = $event;
      },
      "onChange": function onChange() {
        return _this2.setSliderDragging(true);
      },
      "onAfterChange": this.changeProgress
    }, null), (0, _vue.createVNode)("div", {
      "class": "right-minutes"
    }, [this.parseTime(this.currentTime), (0, _vue.createTextVNode)("/"), this.parseTime(this.duration)])])]), (0, _vue.createVNode)("div", {
      "class": "btn",
      "style": this.replayPlayParams.range && this.replayPlayParams.range[0] > 0 ? 'justify-content:center' : ''
    }, [(0, _vue.createVNode)("div", {
      "class": "review",
      "onClick": this.handleOpenReplay
    }, [(0, _vue.createTextVNode)("\u56DE\u653E")]), this.replayPlayParams.range && this.replayPlayParams.range[0] > 0 ? '' : (0, _vue.createVNode)("div", {
      "class": "again",
      "onClick": this.handleUpload
    }, [(0, _vue.createTextVNode)("\u4FDD\u5B58\u8BB0\u5F55")])]), (0, _vue.createVNode)("div", {
      "class": "close-tool-tip",
      "onClick": this.closePlayScoreResultModal
    }, null)])])]);
  }
});

PlayScoreResult.install = function (app) {
  app.component(PlayScoreResult.name, PlayScoreResult);
  return app;
};

var _default = PlayScoreResult;
exports.default = _default;